import { configureStore } from "@reduxjs/toolkit";
import filtersReducer from "./slices/filtersSlice";
import dashboardReducer from "./slices/dashboardSlice";
import uiReducer from "./slices/uiSlice";
import actionPlansReducer from "./slices/actionPlansSlice";
import authReducer from "./slices/authSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    filters: filtersReducer,
    dashboard: dashboardReducer,
    ui: uiReducer,
    actionPlans: actionPlansReducer,
  },
  devTools: import.meta.env.MODE !== "production",
});
